import {BaseOfferClickManager} from '../../../application/clickManagers/BaseOfferClickManager';
import {OfferAnalytics} from './analytics/offerAnalytics';
import {OfferCodeLoader} from './offerCodeLoader';

class OfferClickManager extends BaseOfferClickManager
{
    static get entitySelector() {
        return '[data-list="offer"]';
    }

    static get clickButtonSelector() {
        return '[data-offer="click"]';
    }

    static get conditionsButtonSelector() {
        return '[data-offer="toggle-conditions"]';
    }

    static get conditionsSelector() {
        return '[data-offer="conditions"]';
    }

    static get storageClickedKey() {
        return 'clickedOffers';
    }

    static get urlParamName() {
        return 'oid';
    }
    /**
     * A visited card shows its code instead of the button, so the code is revealed first;
     * cards whose code could not be loaded keep the button.
     *
     * @param {Element[]} elements
     */
    static markVisited(elements) {
        let withCode = elements.filter((element) => element.querySelector('[data-offer-code]'));

        super.markVisited(elements.filter((element) => !withCode.includes(element)));

        OfferCodeLoader.fill(withCode, (filledIds) => {
            super.markVisited(withCode.filter((element) => filledIds.has(Number(element.getAttribute('data-id')))));
        });
    }

    static reversePopup(cardElement) {
        return Number(cardElement.dataset['isShare']) === 1;
    }

    static sendAnalytics(cardElement) {
        let analytics = new OfferAnalytics(),
            isShare = Number(cardElement.dataset['isShare']) === 1;

        isShare ? analytics.sendClickShareEvent() : analytics.sendClickCodeEvent();
    }
}

export {OfferClickManager}
